import { Component, OnInit } from '@angular/core';
import { SecurityHelper } from '../../common/securityHelper';
import { ResetPasswordService } from './reset-password.service';
import swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  token: string = '';
  accountName: string = '';
  errorMessageList: string[] = [];

  newPassword: string = '';
  confirmNewPassword: string = '';

  isCheckingForUpdates = true;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private route: ActivatedRoute,
    private swUpdate: SwUpdate,
  ) {
  }


  async ngOnInit() {

    // Force an update check when it loads.
    if (this.swUpdate.isEnabled) {
      try {
        let updateFound = await this.swUpdate.checkForUpdate();
        if (updateFound) {
          await this.swUpdate.activateUpdate();
          location.reload();
          return;
        }
      } catch (err) {
        console.error('Service worker update check failed.', err);
      } finally {
        this.isCheckingForUpdates = false;
      }
    } else {
      this.isCheckingForUpdates = false;
    }

    this.accountName = '';
    this.errorMessageList = [];

    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  resetPassword() {

    if (this.validate()) {

      // call service:
      this.resetPasswordService.resetPassword(this.accountName).subscribe({
        next: (res: any) => {

          if (this.isResponseValid(res)) {
            let isSuccessful = (res.entity == true);
            let swalMsg = (isSuccessful) ? 'A password reset email has been sent.' : 'Failed to reset password.';

            swal.fire({
              title: 'Reset Password',
              html: `<span>${swalMsg}</span>`,
              icon: (isSuccessful) ? 'success' : 'error',
              showCloseButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            })
              .then((result) => {
                if (result.value) {
                  this.goToLogin();
                }
              });
          }

        },
        error: (err: any) => { this.handleError(err) }
      });
    }
  }

  changePassword() {

    if (this.validate()) {

      // call service:
      this.resetPasswordService.resetPasswordUpdate(this.token, this.newPassword).subscribe(
        (res: any) => {

          if (this.isResponseValid(res)) {

            swal.fire({
              title: 'Successful',
              html: '<span>Your password has been successfully changed.<br>Please log in again to continue.</span>',
              icon: "success",
              showCloseButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            })
              .then((result) => {
                if (result.value) {
                  this.goToLogin();
                }
              });
          }
        });
    }

  }

  private validate() {
    // reset validation
    this.errorMessageList = [];

    if (!this.token) {
      // Reset Password
      if (!this.accountName) {
        this.errorMessageList.push("Username is required.");
      }
    }
    else {
      // Change Password
      if (!this.newPassword || this.newPassword.trim() === '')
        this.errorMessageList.push('Please enter your new password.');

      if (this.newPassword.length > 0 && this.newPassword !== this.confirmNewPassword) {
        this.errorMessageList.push('New and Confirm password did not match.');
      }
    }

    return (this.errorMessageList.length === 0);
  }

  goToLogin() {
    SecurityHelper.GoBackToLoginPage();
  }

  // Common

  handleError(error: any) {
    let errorTitle = error.name ? error.name : 'Error';
    let errorMessage = error.message ? error.message : JSON.stringify(error);

    swal.fire({
      title: errorTitle,
      html: '<span>' + errorMessage + '</span>',
      icon: "error",
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  }

  isResponseValid(res: any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
      this.handleError(res.errorMessage[0]);
    }

    return isValid;
  }

}
